import { $Q } from "./query-selector";

export const loaderAction = (parent) => {
  const loader = $Q(".loader", parent);

  loader.classList.toggle("hidden");
}


export const createLoader = () => {
  const loader = document.createElement('div')
  loader.id = 'loading'
  return loader
}

export const createLoaderWithOverlay = () => {
  const overlay = document.createElement('div')
  overlay.classList.add('loading--overlay')

  const loader = document.createElement('div')
  loader.id = 'loading'

  overlay.appendChild(loader)

  return overlay
}